import { memo, useEffect, useState } from 'react';

import { RecentlyDeletedTableView } from '~/components/RecentlyDeleted/components/RecentlyDeletedTableView';
import { PrivateRecentlyDeletedHeader } from '~/components/v2/components/recently-deleted/PrivateRecentlyDeletedHeader';
import { useScrollElementContext } from '~/components/v2/components/shared/scroll/ScrollElementContextProvider';
import { PrivatePageSeoTitle } from '~/components/v2/components/shared/seo/PrivatePageSeoTitle';

export const PrivateRecentlyDeleted = memo(() => {
  const [isMounted, setIsMounted] = useState(false);

  const { scrollElement } = useScrollElementContext();

  /**
   * This is a hack to ensure the table view is correctly sized when you
   * change between pages due to `useRef` turning `null`.
   */
  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <>
      <PrivatePageSeoTitle title="Recently deleted" />
      <PrivateRecentlyDeletedHeader />
      {scrollElement && isMounted && <RecentlyDeletedTableView scrollElement={scrollElement} />}
    </>
  );
});

PrivateRecentlyDeleted.displayName = 'RecentlyDeleted';
